import { all } from "redux-saga/effects";

import changePasswordWatcher from "./changePasswordSaga";

// Receptionist
import appointmentsSaga from "../sagas/receptionist/appointmentsSaga";
import patientVisitsSagas from "../sagas/receptionist/visitsSaga";
import patientsSagas from "../sagas/receptionist/patientsSaga";
import visitsRoasterSagas from "../sagas/receptionist/visitsRoasterSaga";
import refDoctorsSagas from "../sagas/receptionist/refDoctorsSaga";
// import machinesSagas from "../sagas/receptionist/machinesSaga";
import examCodesSagas from "../sagas/receptionist/examCodesSagas";
import radiologistsSagas from "../sagas/receptionist/radiologistsSaga";
import worklistSagas from "../sagas/receptionist/worklistSaga";
import quickCodesSaga from "../sagas/receptionist/quickCodesSaga";
import pendingVisitorsWatcher from "../sagas/receptionist/pendingVisitorsSaga";
import organisationsServiceSaga from "../sagas/receptionist/organisationServiceSaga";

// common
import rolesSaga from "./common/rolesSaga";
import modalityTypesSaga from "./common/modalityTypesSaga";
import skillsSaga from "./common/skillsSaga";
import scanTypesSaga from "./common/scanTypesSaga";
import bodyPartsSagas from "./common/bodyPartsSaga";
import addressSagas from "./common/addressSaga";
import configurationSaga from "./common/configurationSaga";

//Admin
import mipsSaga from "../sagas/admin/mipsSaga";
import groupsSagaAdmin from "../sagas/admin/groupsSaga";
import adminSitesSaga from "../sagas/admin/adminSitesSaga";
import usersSaga from "../sagas/admin/usersSaga";
import risSaga from "../sagas/admin/risSaga";
import hl7SentMessages from "./admin/hl7SentMessagesSaga";
import hl7ReceivedMessages from "./admin/adminHL7ReceivedMessagesSaga";
import visitsReportSagas from "./admin/visitsReportSaga";
import adminExamCodesSaga from "./admin/adminExamCodesSaga";
import organisationsWatcher from "../sagas/receptionist/organisationsSaga";
import accountsWatcher from "../sagas/receptionist/accountsSaga";

// Roster
import rosterSaga from "./rosterSaga";

// Reserve
import reserveSaga from "../sagas/reserveSaga";

export default function* rootSaga(getState) {
    yield all([
        changePasswordWatcher(),

        // Receptionist
        appointmentsSaga(),
        patientVisitsSagas(),
        patientsSagas(),
        visitsRoasterSagas(),
        refDoctorsSagas(),
        organisationsWatcher(),
        accountsWatcher(),
        // machinesSagas(),
        examCodesSagas(),
        radiologistsSagas(),
        worklistSagas(),
        quickCodesSaga(),
        pendingVisitorsWatcher(),
        organisationsServiceSaga(),

        // Common
        rolesSaga(),
        modalityTypesSaga(),
        skillsSaga(),
        scanTypesSaga(),
        bodyPartsSagas(),
        addressSagas(),
        configurationSaga(),

        //Admin
        usersSaga(),
        adminSitesSaga(),
        groupsSagaAdmin(),
        risSaga(),
        mipsSaga(),
        hl7SentMessages(),
        hl7ReceivedMessages(),
        visitsReportSagas(),
        adminExamCodesSaga(),
        // Roster
        rosterSaga(),

        //Reserve
        reserveSaga(),
    ]);
}
